import { EntityName } from '@provision/entity-types';

export enum EntityViewerStatus {
  active = 'active',
  inactive = 'inactive',
}

export type EntityViewer = {
  viewerId: string;
  lastSeen: number;
  firstName?: string;
  lastName?: string;
  expiresAt: number;
  status: EntityViewerStatus;
};

export type GetEntityViewerResult = {
  getEntityViewer: {
    entity: EntityName;
    entityId: string;
    items: EntityViewer[];
    ts: number;
  };
};

export type GetEntityViewerVars = {
  params: {
    entity: EntityName;
    entityId?: string;
  };
};

export type UpdateEntityViewerVars = {
  params: {
    entity: EntityName;
    entityId: string;
    partnerId: number;
    status: EntityViewerStatus;
    firstName?: string;
    lastName?: string;
  };
};
